import { z } from 'zod'

export const drapeRequestSchema = z.object({
  id: z.string().uuid(),
  salesforce_lead_id: z.string(),
  request_type: z.enum(['anonymize-data']),
  dry_run: z.boolean(),
  drape_received_at: z.string().datetime(),
  created_at: z.string().datetime(),
})

export type DrapeRequest = z.infer<typeof drapeRequestSchema>
export type CreateDrapeRequest = Omit<DrapeRequest, 'id' | 'created_at'>
